import React from 'react'
import { optimizeProfessionalImage } from '../utils/supabaseImageUtils'

const Team = ({ specialists, favorites = [], onFavoriteClick, onSpecialistClick, onBookClick }) => {
  return (
    <section id="team" className="py-12 sm:py-16 lg:py-20 bg-white px-2 sm:px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Our Expert Team
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Meet our talented professionals dedicated to making you look and feel amazing
          </p>
        </div>
        
        {specialists.length === 0 ? (
          <div className="text-center py-16">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-100 mb-4">
              <i className="fas fa-users text-3xl text-purple-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">No Team Members Yet</h3>
            <p className="text-gray-600 max-w-md mx-auto">
              Our team profiles will appear here once they are added through the admin panel.
            </p>
          </div>
        ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {specialists.map((specialist) => (
            <div
              key={specialist.id}
              onClick={() => onSpecialistClick(specialist)}
              className="bg-gray-50 rounded-xl overflow-hidden cursor-pointer transform hover:scale-105 transition duration-300 shadow-md hover:shadow-xl flex flex-col h-full"
            >
              <div className="relative h-64 sm:h-72">
                <img 
                  src={optimizeProfessionalImage(specialist.image_url || specialist.image, 'large')} 
                  alt={specialist.name} 
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="400"
                  height="400"
                />
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                  onFavoriteClick(specialist.id)
                  }}
                  className="absolute top-4 right-4 bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg hover:scale-110 transition"
                  aria-label={favorites.includes(specialist.id) ? 'Remove from favorites' : 'Add to favorites'}
                >
                  <i
                    className={
                      favorites.includes(specialist.id)
                        ? 'fas fa-heart text-red-500'
                        : 'far fa-heart text-gray-600'
                    }
                  ></i>
                </button>
              </div>
              <div className="p-4 sm:p-6 flex flex-col flex-1">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1">
                  {specialist.name}
                </h3>
                <p className="text-sm text-primary mb-2">{specialist.role}</p>
                <div className="flex items-center mb-3">
                  <div className="flex text-yellow-400 text-sm">
                    {[...Array(5)].map((_, i) => {
                      const starIndex = i + 1
                      const rating = specialist.rating || 0
                      // Show filled star if rating is >= starIndex, half-filled if rating is >= starIndex - 0.5
                      const isFilled = rating >= starIndex
                      const isHalfFilled = rating >= starIndex - 0.5 && rating < starIndex
                      
                      return (
                      <i
                        key={i}
                        className={
                            isFilled
                            ? 'fas fa-star'
                              : isHalfFilled
                              ? 'fas fa-star-half-alt'
                            : 'far fa-star'
                        }
                      ></i>
                      )
                    })}
                  </div>
                  <span className="ml-2 text-xs sm:text-sm text-gray-600">
                    {Number(specialist.rating || 0).toFixed(1)}
                  </span>
                </div>
                {specialist.specializations && specialist.specializations.length > 0 && (
                  <div className="mb-4">
                    <p className="text-xs text-gray-500 mb-1">Specializes in:</p>
                    <div className="flex flex-wrap gap-1">
                      {specialist.specializations.slice(0, 3).map((spec, idx) => (
                        <span key={idx} className="text-xs bg-purple-100 text-purple-700 px-2 py-1 rounded">
                          {spec}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    onBookClick(specialist)
                  }}
                  className="w-full mt-auto bg-secondary text-white py-2 sm:py-3 rounded-lg hover:bg-gray-800 transition text-sm sm:text-base"
                >
                  Book Appointment
                </button>
              </div>
            </div>
          ))}
        </div>
        )}
      </div>
    </section>
  )
}

export default Team










